import axios from 'axios';
import store from './store';
import * as _ from 'lodash';

export default function setup() {
    axios.interceptors.request.use((config) => {
        let user = localStorage.getItem("user");
        user = user ? JSON.parse(user) : null;
        let token = _.get(user,'accessToken');
        if(token && !_.includes(config.url,'.amazonaws.com') && !_.includes(config.url,"apidriblab.com") && !_.includes(config.url,"korastats.com")) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    }, function(err) {
        return Promise.reject(err);
    });

    axios.interceptors.response.use(
      (response) => response,
      (error) => {
          console.error('Axios response error:', {
              status: error.response?.status,
              message: error.message
          });

          if (error.response?.status === 401 && localStorage.getItem("user")) {
              store.dispatch('auth/logout');
          }

          return Promise.reject(error);
      }
    );
}
